import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

const jenisKendaraanOptions = [
  { name: "Dutro", id: 1 },
  { name: "Mobil", id: 2 },
  { name: "Trado", id: 17 },
];

const KendaraanServiceFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  return (
    <div className="row-between-end gap-4 w-full">
      {/* filter component section */}
      <div className="row-start-center gap-4 w-full">
        <div className="col-start-start gap-1">
          <div className="row-start-center gap-2">
            <i className="pi pi-search text-slate-500 text-xs" />
            <span className="text-sm font-semibold text-slate-500">Jenis</span>
          </div>
          <Dropdown
            className="w-full"
            value={filterValue.kendaraan_jenis}
            onChange={(e) =>
              setFilterValue({
                ...filterValue,
                kendaraan_jenis: e.value,
                kendaraan_jenis_id: e.value.id,
              })
            }
            options={jenisKendaraanOptions}
            optionLabel="name"
            placeholder="Pilih Jenis"
          />
        </div>

        <div className="col-start-start gap-1 w-[12rem]">
          <div className="row-start-center gap-2">
            <i className="pi pi-search text-slate-500 text-xs" />
            <span className="text-sm font-semibold text-slate-500">
              Nomor Polisi
            </span>
          </div>
          <InputText
            className="w-full"
            value={filterValue.nomor_polisi}
            onChange={(e) =>
              setFilterValue({ ...filterValue, nomor_polisi: e.target.value })
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (onClickRefresh) onClickRefresh();
              }
            }}
          />
        </div>
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default KendaraanServiceFilter;
